/** Valor monetário em Plex Mono tabular — todo número de dinheiro do sistema passa por aqui. */
import { fmtBRL } from '@/lib/format';

export interface MoneyProps {
  value: number;
  /** "lg" para a leitura hero (Fraunces 33px, ex.: total geral da Nova Proposta). */
  size?: 'md' | 'lg';
  className?: string;
}

export function Money({ value, size = 'md', className }: MoneyProps) {
  const cls = size === 'lg' ? 'money-lg' : 'money';
  return <span className={[cls, className].filter(Boolean).join(' ')}>{fmtBRL(value)}</span>;
}
